import { render, staticRenderFns } from "./MsToast.vue?vue&type=template&id=8fa0a3da&scoped=true&lang=html"
import script from "./MsToast.vue?vue&type=script&lang=js"
export * from "./MsToast.vue?vue&type=script&lang=js"
import style0 from "./MsToast.vue?vue&type=style&index=0&id=8fa0a3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa0a3da",
  null
  
)

export default component.exports